export * from '@tolgee/web';

const tolgeeApply = (tolgee, i18n) => {
    const updateTranslations = () => {
        tolgee.getAllRecords().forEach(({ language, namespace, data }) => {
            if (i18n.getResourceBundle(language, namespace)) {
                i18n.addResourceBundle(language, namespace, Object.fromEntries(data), false, true);
            }
        });
    };
    tolgee.on('update', updateTranslations);
    i18n.on('languageChanged', (lang) => {
        if (lang && tolgee.getLanguage() !== lang) {
            tolgee.changeLanguage(lang);
        }
    });
    i18n.tolgee = tolgee;
};

const tolgeeBackend = (tolgee) => {
    return {
        type: 'backend',
        name: 'TolgeeBackend',
        init() { },
        read: async function (language, ns, callback) {
            try {
                const translations = await tolgee.loadRecord({
                    language,
                    namespace: ns,
                });
                callback(null, translations ? Object.fromEntries(translations) : undefined);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                callback(true);
            }
        },
    };
};

const TOLGEE_PROCESSOR_NAME = 'tolgeeProcessor';
const tolgeeProcessor = (tolgee) => {
    return {
        type: 'postProcessor',
        name: 'tolgeeProcessor',
        process: function (value, keyIn, options, translator) {
            var _a, _b, _c, _d, _e, _f;
            const keySeparator = (_c = (_a = options.keySeparator) !== null && _a !== void 0 ? _a : (_b = translator === null || translator === void 0 ? void 0 : translator.options) === null || _b === void 0 ? void 0 : _b.keySeparator) !== null && _c !== void 0 ? _c : '.';
            // if namespace is in the key, we need to extract it
            // https://github.com/i18next/i18next/issues/2049
            const { key, namespaces } = translator.extractFromKey(keyIn.join(keySeparator), options);
            const ns = (_e = (_d = namespaces === null || namespaces === void 0 ? void 0 : namespaces[0]) !== null && _d !== void 0 ? _d : options.ns) !== null && _e !== void 0 ? _e : (_f = translator === null || translator === void 0 ? void 0 : translator.options) === null || _f === void 0 ? void 0 : _f.defaultNS;
            return tolgee.wrap({
                key,
                defaultValue: options.defaultValue,
                translation: value,
                ns,
            });
        },
    };
};

const tolgeeOptions = (tolgee, options) => {
    var _a, _b;
    let processors;
    if (typeof options.postProcess === 'string') {
        processors = [options.postProcess, TOLGEE_PROCESSOR_NAME];
    }
    else if (Array.isArray(options.postProcess)) {
        processors = [...options.postProcess, TOLGEE_PROCESSOR_NAME];
    }
    else {
        processors = [TOLGEE_PROCESSOR_NAME];
    }
    const newOptions = Object.assign(Object.assign({}, options), { postProcess: processors, i18nFormat: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.i18nFormat), { 
            // @ts-ignore
            bindI18nStore: 'added ' + ((_a = options.i18nFormat) === null || _a === void 0 ? void 0 : _a.bindI18nStore) || '' }), react: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.react), { 
            // @ts-ignore
            bindI18nStore: 'added ' + ((_b = options.react) === null || _b === void 0 ? void 0 : _b.bindI18nStore) || '' }) });
    return newOptions;
};

const withTolgee = (i18n, tolgee) => {
    i18n.use(tolgeeBackend(tolgee));
    i18n.use(tolgeeProcessor(tolgee));
    const originalInit = i18n.init;
    const newInit = (...params) => {
        tolgeeApply(tolgee, i18n);
        let options = {};
        let callback = undefined;
        if (typeof params[0] === 'object') {
            options = params[0];
            callback = params[1];
        }
        else {
            callback = params[0];
        }
        const newOptions = tolgeeOptions(tolgee, options);
        const result = originalInit(newOptions, callback);
        const language = i18n.language || options.lng;
        if (language) {
            tolgee.changeLanguage(language);
        }
        tolgee.run();
        return result;
    };
    i18n.init = newInit;
    return i18n;
};

const I18nextPlugin = () => (tolgee) => {
    tolgee.updateOptions({ ns: [], defaultNs: undefined });
    return tolgee;
};

export { I18nextPlugin, TOLGEE_PROCESSOR_NAME, tolgeeApply, tolgeeBackend, tolgeeOptions, tolgeeProcessor, withTolgee };
//# sourceMappingURL=tolgee-i18next.esm.js.map
